import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Home from "./pages/Home";
import SellProperty from "./pages/SellProperty";
import Contact from "./pages/Contact";
import Results from "./pages/Results";
import Property from "./pages/Property";
import Properties from "./pages/Properties";
import About from "./pages/About";
import DisputeResolution from "./pages/DisputeResolution";
import TermsAndConditions from "./pages/TermsAndConditions";
import CookiesPolicy from "./pages/CookiesPolicy";
import News from "./pages/News";
import Error from "./pages/Error";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const LegacyNewsRedirect = () => {
  const { date, slug } = useParams();

  return date && slug ? (
    <Navigate to={`/news/${date}/${slug}`} replace />
  ) : (
    <Navigate to="/news" replace />
  );
};

export const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/sell" element={<SellProperty />} />
        <Route path="/results" element={<Results />} />
        <Route path="/property/:id" element={<Property />} />
        <Route path="/:id" element={<Property />} />
        <Route path="/contact/:id" element={<Contact />} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/about" element={<About />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:date/:slug" element={<News />} />
        <Route path="/noticias" element={<Navigate to="/news" replace />} />
        <Route path="/noticias/:date/:slug" element={<LegacyNewsRedirect />} />
        <Route path="/dispute-resolution" element={<DisputeResolution />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/cookies-policy" element={<CookiesPolicy />} />
        <Route path="/error" element={<Error />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};
